export const EOpportunityType = {
  ONLINE_COURSE: {
    key: 'ONLINE_COURSE',
    label: 'Online Course'
  },
  EBOOK: {
    key: 'EBOOK',
    label: 'E-book'
  },
  VIDEO: {
    key: 'VIDEO',
    label: 'Video'
  },
  COACH: {
    key: 'COACH',
    label: 'Coach'
  },
  EVENT: {
    key: 'EVENT',
    label: 'Event',
    supportsLocation: true
  },
  JOB: {
    key: 'JOB',
    label: 'Job Offer',
    supportsLocation: true
  },
  TALENT_ACADEMY: {
    key: 'TALENT_ACADEMY',
    label: 'Talent Academy'
  },
  BOOK: {
    key: 'BOOK',
    label: 'Book'
  },
  ARTICLE: {
    key: 'ARTICLE',
    label: 'Article'
  }
};


export const EMetric = {
  CUSTOMER_ORIENTATION: {
    key: 'CUSTOMER_ORIENTATION',
    label: 'Customer Orientation'
  },
  EFFECTIVE_COMMUNICATION: {
    key: 'EFFECTIVE_COMMUNICATION',
    label: 'Effective Communication'
  },
  INFORMATION_PROCESSING: {
    key: 'INFORMATION_PROCESSING',
    label: 'Information processing'
  },
  INTEGRITY: {
    key: 'INTEGRITY',
    label: 'Integrity'
  },
  NUMERACY: {
    key: 'NUMERACY',
    label: 'Numeracy'
  },
  PROBLEM_SOLVING: {
    key: 'PROBLEM_SOLVING',
    label: 'Problem Solving'
  },
  SELF_KNOWLEDGE: {
    key: 'SELF_KNOWLEDGE',
    label: 'Self-knowledge'
  }
};

export const EMediaType = {
  IMAGE: {
    key: 'IMAGE',
    label: 'Image',
    supportsUpload: true
  },
  VIDEO: {
    key: 'VIDEO',
    label: 'Video',
    supportsUpload: true
  },
  WEBSITE: {
    key: 'WEBSITE',
    label: 'Website'
  },
  FILE: {
    key: 'FILE',
    label: 'File',
    supportsUpload: true
  },
  EMBEDDED_CONTENT: {
    key: 'EMBEDDED_CONTENT',
    label: 'Embedded Content'
  }
};



// WEBPACK FOOTER //
// ./src/constants/Enums.js